import React from 'react';
import { Navigate } from 'react-router-dom';

// Fase 3 implementada - redireciona para a lista
export default function PlaylistCreate() {
  return <Navigate to="/playlists" replace />;
}
